// import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'appointment_list',
    component: () => import('./List.vue'),
  },
]
